import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorSend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M22.25 16.658a3.75 3.75 0 0 1-3.75 3.75h-12a3.75 3.75 0 0 1-3.75-3.75v-2.684a.75.75 0 0 1 1.5 0v2.684a2.25 2.25 0 0 0 2.25 2.25h12a2.25 2.25 0 0 0 2.25-2.25v-2.684a.75.75 0 0 1 1.5 0v2.684Z"
    />
    <path
      fill="#F7A600"
      d="M13.33 3.97a.75.75 0 0 0-1.06 0l-4.5 4.5a.75.75 0 0 0 1.06 1.06l3.22-3.219v8.439a.75.75 0 0 0 1.5 0V6.31l3.22 3.22a.75.75 0 1 0 1.06-1.06l-4.5-4.5Z"
    />
  </svg>
);
export default SvgTwoColorSend;
